<app-header></app-header>
<div class="container-fluid bg-refund" [style.font-family]="'var(--vex-font)'">
  <div class="container py-24">
    <p class="text-center text-5xl font-bold text-white">Enroll</p>
    <p class="pt-8 text-4xl text-center font-bold text-white">Refund & Cancellation Policy</p>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-xl text-zinc-500">Welcome to Enroll! We strive to provide excellent service and satisfaction to our customers. Our
      goal is to give our clients outstanding service and happiness. We work hard to deliver the greatest user
      experience and client contentment. We are aware, nonetheless, that there might be circumstances in which you must
      stop using a service or request a refund. The standards and procedures for such circumstances are outlined in this
      Refund and Cancellation Policy.
      This Refund Policy describes how Enroll, an admission management system, handles refunds. The practices of
      businesses that Enroll does not own, control, or manage, as well as any third-party service and/or product
      suppliers under contract, as well as any third-party websites that link from Enroll websites, are not covered by
      this refund policy.</p>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container bg-heading rounded-2xl p-8">
    <p class="text-4xl text-white text-center">Refund Policy</p>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container text-justify">
    <p class="text-xl pt-6 text-zinc-500">We offer a [number]-day money-back guarantee on our admission management software within a
      specific
      period. If you are not satisfied with your purchase for any reason, you may request a refund within [number] days
      from the date of purchase.</p>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-4xl font-semibold">Eligibility For Initiate Refund</p>
    <ul class="list-disc pt-8 text-zinc-500">
      <li><p class="text-xl"><b>Technical Issues:</b> If you encounter serious technical issues or compatibility
        problems with our program that hinder its correct operation and our support team is unable to remedy the problem
        within a reasonable time limit.</p>
      </li>
      <li><p class="text-xl"><b>Dissatisfaction:</b>If you have voiced your concerns to our support team and offered
        helpful
        input, and you are unhappy with the features or functionality of our program.</p>
      </li>
      <li><p class="text-xl"><b>Unlawful Charges:</b>Should you discover that a purchase you made on our website
        resulted in unlawful charges on your credit or debit card.</p>
      </li>
    </ul>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-4xl font-semibold">Refund Process</p>
    <ul class="list-disc pt-8 text-zinc-500">
      <li><p class="text-xl"><b>Contact Customer Support:</b>Send our customer support staff a refund request by
        supplying
        pertinent information about your purchase, including the order number, the date of purchase, and the
        justification for the return.</p>
      </li>
      <li><p class="text-xl"><b>Evaluation:</b>Following the eligibility requirements, our support staff will
        assess your request.</p>
      </li>
      <li><p class="text-xl"><b>Refund Decision:</b>We will begin the refund procedure within 5-7 business days if your
        request
        satisfies the qualifying requirements. The refund will be given using the original payment method. Please be
        aware that depending on your banking institution, it can take longer for the refund to show up on your account
        statement.</p>
      </li>
      <li><p class="text-xl"><b>Program Deactivation:</b>You will need to uninstall and deactivate the program when your
        refund has been approved. Any further use of the software or access to it could result in legal issues.</p>
      </li>
    </ul>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container bg-heading rounded-2xl p-8">
    <p class="text-4xl text-white text-center">Cancellation Policy</p>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-4xl font-semibold">Products and Services Based on Subscription</p>
    <p class="pt-6 text-xl text-zinc-500">You are always free to stop using any subscription-based goods or services. You will be able
      to use the good or service after canceling till the conclusion of the current payment cycle. You won't be charged
      anything more. Please contact our customer support team or follow the steps found in your account settings to
      cancel your membership.</p>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-4xl font-semibold">Products with Perpetual Licenses</p>
    <p class="pt-6 text-xl text-zinc-500">Products with perpetual licenses are one-time purchases with no time limit. Perpetual
      license items are not subject to cancellation because they are not based on a subscription model.</p>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-4xl font-semibold">Exceptions</p>
    <ul class="list-disc pt-8 text-xl text-zinc-500">
      <li>We reserve the right to refuse a refund if the request is made after the 15-days refund period.</li>
      <li>Refunds are not available for renewal payments or subscription fees.</li>
      <li>If you eventually decide you no longer want to utilize our services or software, provided that everything is
        working as it should and there are no problems with the program.
      </li>
      <li>Even if they are sold via our platform, refunds are not offered for goods or services supplied by outside
        merchants. Kindly consult their return policies.
      </li>
    </ul>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-4xl font-semibold">Policy Updated</p>
    <p class="pt-6 text-xl text-zinc-500">This Refund and Cancellation Policy is subject to change at any moment and without notice.
      The most recent version will be available on our website, and the modifications will take effect as soon as they
      are posted. Please be aware that only purchases bought directly from our business are covered by this policy.
      Please review the refund and cancellation policies of the third-party merchant or distributor if you purchased our
      software from them. Please get in touch with our customer service staff if you have any questions or complaints
      about this policy.</p>
  </div>
</div>

<div class="container-fluid mt-10" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-4xl font-semibold">Contact Us</p>
    <p class="pt-6 text-xl text-zinc-500">If you have any questions about our Refund and Return Policy, please contact us at <a
      href="mailto:support@volmint.com"><u class="font-semibold">support&#64;volmint.com</u></a>.
      This Refund and Return Policy aims to provide clarity and transparency regarding refunds and returns for your
      admission management software, "Enroll."</p>
  </div>
</div>

<div class="above-footer mt-10 py-12" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container">
    <div class="m-auto text-center">
      <img src="./assets/images/img-group.png" alt="" class="mx-auto">
      <h3 class="mt-5 text-white text-xl font-medium">
        Need any further assistance?
      </h3>
      <p class="mt-4 text-white ">
        Feel free to reach out for any inquiries or assistance.
      </p>
      <button type="button" class="mt-5 px-3 py-2 bg-white text-[#6752A9] rounded" (click)="goTo('/contact-us')">
        Book an appointment now!
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>
